<template>
  <div class="t-app__container">
    <heading :title="$t('login-title')" />
    <div class="h-section h-section--no-margin-top">
      <div class="h-grid h-grid--justify-content-center">
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <s-form @submit="login">
            <p class="m-form-group">
              <label class="a-form-label" for="email">{{ $t('label-email') }}</label>
              <input class="a-form-control" id="email" :value="email" @change="setEmail($event.target.value)" />
              <span v-if="$v.email.$dirty">
                <span class="m-form-group__error" v-if="!$v.email.required">{{ $t('error-field-required') }}</span>
                <span class="m-form-group__error" v-if="!$v.email.email">{{ $t('error-field-not-email') }}</span>
              </span>
            </p>
            <p class="m-form-group">
              <label class="a-form-label" for="password">{{ $t('label-password') }}</label>
              <input type="password" class="a-form-control" id="password" :value="password" @change="setPassword($event.target.value)" />
              <span v-if="$v.password.$dirty">
                <span class="m-form-group__error" v-if="!$v.password.required">{{ $t('error-field-required') }}</span>
              </span>
            </p>
            <div class="m-form-ctrl">
              <div class="m-form-ctrl__item">
                <button class="a-btn-primary" type="submit">{{ $t('button-login') }}</button>
              </div>
              <div class="m-form-ctrl__item">
                <router-link :to="{ name: $consts.urls.URL_ACCOUNT_SUBSCRIBE }">{{ $t('user-subscribe') }}</router-link>
              </div>
              <div class="m-form-ctrl__item">
                <router-link :to="{ name: $consts.urls.URL_ACCOUNT_FORGOT_PASSWORD }">{{ $t('button-forgot-password') }}</router-link>
              </div>
            </div>
          </s-form>
        </div>
      </div>
    </div>

    <div class="t-app__confetti t-app__confetti--01"></div>
    <div class="t-app__dot t-app__dot--large"></div>
    <div class="t-app__confetti t-app__confetti--02"></div>
    <div class="t-app__confetti t-app__confetti--03"></div>
    <div class="t-app__confetti t-app__confetti--04"></div>
    <div class="t-app__dot t-app__dot--medium"></div>
    <div class="t-app__confetti t-app__confetti--05"></div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import StatusHelper from '@/helpers/status'

import Heading from '@/components/heading'
import SForm from '@/components/form/form'

import AuthentificationService from '@/services/authentification'
import LoaderService from '@/services/loader'
import UserService from '@/services/user'
import Notification from '@/services/notification'

export default {
  components: {
    SForm,
    Heading
  },
  data() {
    return {
      token: this.$router.currentRoute.query.token,
      email: this.$router.currentRoute.query.email,
      password: ''
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },
  async mounted() {
    if (this.token) {
      const response = await UserService.completeUserRegistration(this.email, this.token)
      if (StatusHelper.isSuccess(response.status)) {
        Notification.showSuccess(this.$t('emailconfirm-success'))
      } else {
        Notification.showError(this.$t('error-basic'))
      }
    }
  },
  methods: {
    login: async function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        LoaderService.showLoader()
        await AuthentificationService.login(this.email, this.password)
        LoaderService.hideLoader()
      }
    },
    setEmail(value) {
      this.email = value
      this.$v.email.$touch()
    },
    setPassword(value) {
      this.password = value
      this.$v.password.$touch()
    }
  }
}
</script>
